import { BaseResource } from "./BaseResource";
import { CustomerType } from "./ProductResource";
import { schema } from "@rest-hooks/rest";
import { ApplicationResource } from "./ApplicationResource";
import { CustomerRole } from "@ploy-lib/types";
class ContactInfoResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.role = CustomerRole.NotSet;
        this.type = CustomerType.NotSet;
        this.contactPerson = "";
        this.contactPersonEmail = "";
        this.phoneMobile = "";
        this.email = "";
        this.phoneHome = "";
    }
    pk() {
        return this.id?.toString();
    }
    static detail() {
        return super.detail();
    }
    static detailAll() {
        return this.detail().extend({ schema: new schema.Values(this) });
    }
    static update() {
        return super.update();
    }
    static updateAll() {
        return this.update().extend({ schema: new schema.Values(this) });
    }
}
ContactInfoResource.urlTemplates = [
    `${ApplicationResource.urlRoot}/{applicationNumber}/contact-info/{role}`,
    `${ApplicationResource.urlRoot}/{applicationNumber}/contact-info`
];
ContactInfoResource.urlRoot = `${ApplicationResource.urlRoot}/{applicationNumber}/contact-info/{role}`;
export { ContactInfoResource };
//# sourceMappingURL=ContactInfoResource.js.map